import { FC } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const FooterWrapper = styled.footer`
  background-color: #0a0a0a;
  color: #fff;
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
  }

  a {
    color: rgba(255, 255, 255, 0.7);
    font-size: 1.2rem;
    transition: all 0.3s ease;

    &:hover {
      color: var(--primary-color);
      transform: translateY(-2px);
    }
  }
`;

const Copyright = styled.div`
  font-family: var(--secondary-font-family);
  opacity: 0.7;
  font-size: 0.9rem;
  
  a {
    color: #fff;
    text-decoration: none;
    
    &:hover {
      color: var(--primary-color);
    }
  }
`;

const Footer: FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <Container>
        <Copyright>
          <span>
            {'<'}
            <a href="https://github.com/Haja-dev/" target="_blank" rel="noopener noreferrer">
              Haja
            </a>
            {'/>'} © {currentYear}
          </span>
        </Copyright>

        <p><a href="https://ko-fi.com/hajadevelops" target="_blank" title="Buy me a coffee or a soup bowl">☕Buy me a coffee</a></p>
        
        <SocialLinks>
          <a href="https://github.com/Haja-dev" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <a href="https://twitter.com/Haja261M" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        </SocialLinks>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;